<template>
	<div class="box">
		<h2>{{ $t('invoice.select_invoice_to_send') }} : </h2>
		<CustomTable
            id_table="invoices_created"
            ref="invoices_created"
            :items="invoices_local"
            primaryKey="invoice_id"
            :hrefsRoutes="config_table_hrefs"
            :hide_if_empty="true"
            :busy.sync="table_busy"
            :externSlotColumns="extern_slot_columns"
        >
            <template v-slot:[`custom-slot-cell(invoice_num)`]="{ data }">
                <a href="" class="" @click.prevent="quickPreview(data.invoice_id)">
                   {{ data.invoice_num }} <font-awesome-icon :icon="['fas', 'eye']" />
                </a>
            </template>
        </CustomTable>

        <ModalSendInvoice ref="modal_send_invoice" :first_send="true" @submit="submitSend"/>

        <b-modal size="xl" ref="modal_preview" hide-footer @hidden="base64 = null">
            <template v-slot:modal-title>
                {{ $t("action.previsualiser") }}
            </template>

            <iframe v-if="base64 != null" :src="'data:application/pdf;base64,' + base64" height="1000px" width="100%" style="position:relative"></iframe>
            <div v-else>
                <LoadingSpinner />
            </div>
        </b-modal>
	</div>
</template>

<script type="text/javascript">
    import Invoice from "@/mixins/Invoice.js"
    import Navigation from "@/mixins/Navigation.js"
    import _deepClone from 'lodash/cloneDeep'

	export default {
		name: 'ListCreated',
		mixins: [Invoice, Navigation],
		props: ['invoices', 'from', 'params', 'reload'],
		data () {
			return {
                config_table_hrefs: {
                    'tiers.tiers_rs': {
                        routeUniqueName: 'tiersFiche_1',
                        routeName: 'tiersFiche',
                        params: {
                            tiers_id: 'tiers.tiers_id'
                        }
                    },
                    'author.tiers_rs': {
                        routeUniqueName: 'tiersFiche_2',
                        routeName: 'tiersFiche',
                        params: {
                            tiers_id: 'author.tiers_id'
                        }
                    }
                },
                events_tab: {
                    'TableAction::goToSendInvoice': this.openModalSendInvoice,
                    'TableAction::goToSkip': this.skip
                },
                extern_slot_columns: ['invoice_num'],
                invoices_local: [],
                invoices_selected: [],
                table_busy: true,
                base64: null
			}
		},

        mounted() {
            this.init_component()
        },

		methods: {
            async init_component() {
                if(!this.reload) {
                    this.invoices_local = _deepClone(this.invoices)
                }
                else {
                    // s'il y a eu un règlement créé dans la modal d'avoir et de CC les soldes ont changé donc je dois aller rechercher les bons
                    const invoices_ids = this.invoices.map(invoice => invoice.invoice_id).join(',')
                    this.invoices_local = await this.getInvoiceById(invoices_ids)
                }
                this.table_busy = false
            },

			submitSend() {
				this.$refs.invoices_created.unselectAll()
                const selected_ids = this.invoices_selected.map(invoice => invoice.invoice_id)
                this.invoices_local = this.invoices_local.filter(invoice => selected_ids.includes(invoice.invoice_id))
                if(this.invoices_local.length == 0) {
                    this.skip()
                }
			},

            async openModalSendInvoice(params) {
                this.invoices_selected = await this.$refs.invoices_created.getSelected()
				this.$refs.modal_send_invoice.openModal(params.invoice_ids, params.author_ids)
			},

            skip() {
                this.$router.push({name: this.from, params: this.params})
            },

            async quickPreview(invoice_id) {
                this.$refs.modal_preview.show()
                let retour = await this.pdfInvoice([invoice_id], "", true)
                if(retour) {
                    this.base64 = retour
                }
            }
		},

		components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
            ModalSendInvoice : () => import('@/components/Tiers/ModalSendInvoice'),
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}

</script>